import React, { useState } from "react";
import { Button } from "../core/button";
import { EyeIcon } from "lucide-react";

export interface LazyMediaProps {
  children: React.ReactElement;
  title?: string;
  placeholder: string;
  onReplace?: () => void;
  showReplaceButton?: boolean;
  className?: string;
}

/**
 * LazyMedia component that only renders its children when explicitly requested by the user.
 * Useful for optimizing performance by delaying the loading of potentially heavy media content.
 */
export const LazyMedia = ({
  children,
  title,
  placeholder,
  onReplace,
  showReplaceButton = true,
  className = "",
}: LazyMediaProps) => {
  const [showPreview, setShowPreview] = useState(false);

  if (!showPreview) {
    return (
      <div className={`flex justify-between items-center p-3 bg-muted rounded-md ${className}`}>
        <span className="text-sm">{placeholder}</span>
        <Button 
          size="sm"
          variant="outline"
          onClick={() => setShowPreview(true)}
        >
          <EyeIcon className="h-4 w-4 mr-1" /> Preview
        </Button>
      </div>
    );
  }

  return (
    <div className={`relative ${className}`}>
      {children}
      <div className="absolute top-2 right-2 flex gap-2">
        <Button 
          size="sm" 
          variant="outline" 
          className="bg-background"
          onClick={() => setShowPreview(false)}
        >
          Hide
        </Button>
        {showReplaceButton && onReplace && (
          <Button 
            size="sm" 
            variant="outline" 
            className="bg-background"
            onClick={onReplace}
          >
            Replace
          </Button>
        )}
      </div>
    </div>
  );
}; 